import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import file from "../../../../assets/svg/File.svg";
import category from "../../../../assets/svg/category.svg";
import $ from "jquery";
import role from "../../../../assets/svg/role.svg";
import calender from "../../../../assets/svg/calender.svg";
import infoBlack from "../../../../assets/svg/infoBlack.svg";
import versionBlack from "../../../../assets/svg/versionBlack.svg";
import archiveWhite from "../../../../assets/svg/archiveWhite.svg";
import remark from "../../../../assets/svg/remark.svg";
import { archiveTrigger, rightBarClose } from "../../../../redux/action/Action";
import {
  GET_DOCUMENT_BY_ID,
  GET_DOCUMENT_PROPERTIES,
  GET_VERSION_HISTORY,
  GET_VERSION_LOG,
  PUT_ARCHIVE,
  PUT_OBSOLETE,
} from "../../../../helpers/endpointService";
import axios from "axios";
import Moment from "moment";
import { PulseLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logoutFunction } from "../../../custom/commonFunction";

export default function Archive({ rightbarOpen, rightbarId }) {
  const dispatch = useDispatch();
  const userRole = localStorage.getItem("Role");
  const [docProp, setDocProp] = useState();
  const [docVersion, setDocVersion] = useState();
  const [reason, setReason] = useState("");
  const [isPropertyLoader, setPropertyLoader] = useState(true);
  const [isPropertyFailed, setPropertyFailed] = useState(false);

  useEffect(() => {
    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }
    const fetchData = async () => {
      let propApiUrl = `${GET_DOCUMENT_BY_ID}?docId=${rightbarId}`;
      await axios
        .get(propApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setPropertyFailed(false);
            fetchVersion();
            setDocProp(response.data);
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          setPropertyFailed(true);
          logoutFunction(err?.response?.status);
        });
    };
    fetchData();

    const fetchVersion = async () => {
      let versionApiUrl = `${GET_VERSION_LOG}?docId=${rightbarId}`;
      await axios
        .get(versionApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setDocVersion(response.data);
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };
  }, [rightbarId]);

  const close = () => {
    dispatch(rightBarClose());
    $("body").removeClass("scrollhide");
  };

  const archiveFile = async () => {
    let user = localStorage.getItem("UserId");
    let userId = parseInt(user);
    setPropertyLoader(true);
    let apiUrl = `${PUT_ARCHIVE}?userId=${userId}`;
    const obsoleteDetails = {
      id: rightbarId,
      documentName: docProp.documentName,
      documentNo: docProp.documentNo,
      reason: reason,
    };
    axios({
      method: "PUT",
      url: apiUrl,
      data: obsoleteDetails,
    })
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          if (response.data === "success") {
            toast.success("Archived successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });

            dispatch(archiveTrigger());
            dispatch(rightBarClose());
          } else {
            toast.warn(response.data, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((err) => {
        setPropertyLoader(false);

        toast.error("Archived failed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
        logoutFunction(err?.response?.status);
      });
  };

  return (
    <>
      <div className={`viewbar ${rightbarOpen ? "viewbarOpen" : ""}`}>
        {isPropertyLoader && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )}

        {isPropertyFailed && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <span>Loading failed</span>
            </div>
          </div>
        )}

        <ToastContainer
          limit={1}
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <div className="viewMain">
          <div className="viewTitle">
            <span>{docProp?.documentNo}</span>
            {!isPropertyLoader && (
              <span className="close mt-2" onClick={close}>
                ✕
              </span>
            )}
          </div>
          {docProp && (
            <div className="inputSection">
              <div className="row">
                <div className="col-sm-6 col-12">
                  <span>
                    <img
                      style={{ position: "relative", top: "-1px" }}
                      src={infoBlack}
                      alt=""
                    />{" "}
                    Document no.
                  </span>
                  <br />
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.documentNo}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={file} alt="" />
                    <span> Document name</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.documentName}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={role} alt="" />
                    <span> Author</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.authorName}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={infoBlack} alt="" />
                    <span> Version</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.version}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={category} alt="" />
                    <span> Category 1</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.category1Name}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={category} alt="" />
                    <span> Category 2</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.category2Name}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={calender} alt="" />
                    <span> Published date</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.publishedDate
                      ? Moment(
                          new Date(Date.parse(docProp.publishedDate))
                        ).format("DD-MMM-YYYY")
                      : "-"}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={calender} alt="" />
                    <span> Expiry date</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.reviewDate
                      ? Moment(new Date(Date.parse(docProp.reviewDate))).format(
                          "DD-MMM-YYYY"
                        )
                      : "-"}
                  </span>
                </div>
              </div>
              {userRole === "Admin" && (
                <div className="row">
                  <div className="col-sm-6 col-12">
                    <div className="inputTitle">
                      <img src={infoBlack} alt="" />
                      <span>Status</span>
                    </div>
                    <span
                      style={{
                        fontWeight: "400",
                        color:
                          docProp.status === "Active"
                            ? "#21A366"
                            : docProp.status === "Obsolete"
                            ? "#D12232"
                            : "#FF9000",
                      }}
                    >
                      {docProp.status}
                    </span>
                  </div>
                </div>
              )}
              <div className="col-12 mt-3">
                <div className="inputTitle">
                  <img src={remark} alt="" />
                  <span> Reason to archive</span>
                </div>
                <textarea
                  onChange={(e) => setReason(e.target.value)}
                  value={reason}
                  className="form-control border-radius shiptype-select mt-2"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
              <div className="button" onClick={archiveFile}>
                <button id="edit">
                  <img
                    style={{ marginTop: "-4px", width: "14px" }}
                    src={archiveWhite}
                    alt=""
                  />{" "}
                  Archive
                </button>
              </div>

              <div className="col-12 mt-3">
                <div className="inputTitle">
                  <img src={versionBlack} alt="" />
                  <span> Versions</span>
                </div>
                <div className="row mt-1">
                  <div className="col-3">
                    <div className="inputTitle">
                      <span> Version</span>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="inputTitle">
                      <span> Author</span>
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="inputTitle">
                      <span style={{ whiteSpace: "nowrap" }}>
                        {" "}
                        Published date/time
                      </span>
                    </div>
                  </div>
                </div>
                {docVersion &&
                  (docVersion?.length > 0 ? (
                    docVersion?.map((list, index) => {
                      return (
                        <div className="row mt-1" key={index}>
                          <div className="col-3">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                style={{ fontWeight: "400", color: "#605E5C" }}
                              >
                                {list.documentVersion}
                              </span>
                            </div>
                          </div>
                          <div className="col-4">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                style={{ fontWeight: "400", color: "#605E5C" }}
                              >
                                {list.authorName}
                              </span>
                            </div>
                          </div>
                          <div className="col-5">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span style={{ fontWeight: "400" }}>
                                {list.publishedDate
                                  ? Moment(
                                      new Date(Date.parse(list.publishedDate))
                                    ).format("DD-MMM-YYYY h:mm a")
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        height: "50px",
                      }}
                    >
                      <span
                        style={{
                          color: "#605e5c",
                          fontWeight: "400",
                          position: "relative",
                          top: "25px",
                          left: "-19px",
                          fontSize: "14px",
                        }}
                      >
                        No version history
                      </span>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
